<script setup>
defineEmits(['select'])
defineProps({
  shortcuts: {
    type: Array,
    default: () => [4, 6, 12],
  },
  align: {
    type: String,
    default: 'center',
  },
  hoverEnabled: {
    type: Boolean,
    default: false,
  },
  activeMonths: {
    type: Number,
    default: null,
  },
})

</script>

<template>
  <div class="flex gap-2 w-full pb-1 mx-[0.4rem]" :class="align === 'around' ? 'justify-around' : 'justify-center'">
    <div
      v-for="months in shortcuts"
      :key="months"
      class="cursor-pointer group flex pt-1"
      @click="$emit('select', months)"
    >
      <Tag
        :value="`${months} kuud`"
        severity="primary"
        :data-testid="'date-shortcut-' + months"
        class="cursor-pointer text-xs px-1 py-0.5 tracking-tighter hover:bg-primary hover:text-white rounded-sm"
        :class="months === activeMonths
          ? 'date-shortcut-active bg-primary-500! text-white! font-semibold'
          : { 'opacity-70 group-hover:opacity-100': hoverEnabled }"
      />
    </div>
  </div>
</template>
